import { useState, useEffect } from 'react';
import apiClient from '../api/client';

export const useSubscriptionPlans = () => {
  const [plans, setPlans] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Use public endpoint that doesn't require authentication
      const response = await apiClient.get('/billing/public/subscription-plans');
      
      if (response.data.success) {
        setPlans(response.data.plans || {});
      } else {
        throw new Error('Failed to fetch subscription plans');
      }
    } catch (err) {
      console.error('Error fetching subscription plans:', err);
      setError(err.response?.data?.detail || err.message || 'Failed to fetch subscription plans');
      
      // Fallback to hardcoded plans if API fails
      setPlans(getFallbackPlans());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  return {
    plans,
    loading,
    error,
    refetch: fetchPlans
  };
};

// Fallback plans (current hardcoded values) in case API fails
const getFallbackPlans = () => ({
  basic: {
    name: 'basic',
    display_name: 'Basic Plan',
    monthly_price: 99,
    annual_price: 996,
    features: [
      'Up to 1,000 clients',
      'Email automation campaigns',
      'Basic reporting & analytics',
      'Pabau integration',
      'Email support',
      '14-day free trial'
    ],
    tier_level: 1,
    is_active: true
  },
  pro: {
    name: 'pro',
    display_name: 'Pro Plan',
    monthly_price: 200,
    annual_price: 2004,
    features: [
      'Up to 10,000 clients',
      'Advanced automation workflows',
      'Detailed analytics & insights',
      'A/B testing campaigns',
      'Priority email support',
      'Custom integrations',
      '14-day free trial'
    ],
    tier_level: 2,
    is_active: true
  },
  enterprise: {
    name: 'enterprise',
    display_name: 'Enterprise Plan',
    monthly_price: 350,
    annual_price: 3504,
    features: [
      'Unlimited clients',
      'Custom automation workflows',
      'Advanced reporting suite',
      'Dedicated account manager',
      'Phone & email support',
      'Custom onboarding',
      'SLA guarantees',
      '14-day free trial'
    ],
    tier_level: 3,
    is_active: true
  }
});

export default useSubscriptionPlans; 
